/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_AcceptInputs */

const en_us2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree, let's take the photos`)
};

const pt_br2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concordo, vamos às fotos`)
};

const es_419_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acepto, vamos a las fotos`)
};

const pt_pt2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concordo, vamos às fotos`)
};

const fr_fr2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'accepte, place aux photos`)
};

const de_de2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverstanden, los geht's`)
};

const it_it2_body_assessment_consent_accept = /** @type {(inputs: Body_Assessment_Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetto, facciamo le foto`)
};

/**
* | output |
* | --- |
* | "I agree, let's take the photos" |
*
* @param {Body_Assessment_Consent_AcceptInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_accept = /** @type {((inputs?: Body_Assessment_Consent_AcceptInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_AcceptInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_accept(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_accept(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_accept(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_accept(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_accept(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_accept(inputs)
	return en_us2_body_assessment_consent_accept(inputs)
});
export { body_assessment_consent_accept as "body-assessment.consent_accept" }